import Apis from '@/Apis/_'
import moment from 'moment'

export interface InvalidSchedulingDate {
  data: string
}

export interface SurgerySchedulingLimitParams {
  hospitalId: string
  complexity: 'Baixa' | 'Media' | 'Alta'
  initialDate: string
  roomId?: string
  surgeryCenterId?: string
}

export interface BuildSurgerySchedulingLimitParams {
  shouldCheck: boolean
  hospitalId: string
  complexity?: 'Baixa' | 'Media' | 'Alta' | null
  roomId?: string
  surgeryCenterId?: string
}

export function getSchedulingLimitInitialDate() {
  return new Date().toISOString().slice(0, 10)
}

export function buildSurgerySchedulingLimitParams(params: BuildSurgerySchedulingLimitParams): SurgerySchedulingLimitParams | null {
  const {
    shouldCheck,
    hospitalId,
    complexity,
    roomId,
    surgeryCenterId,
  } = params

  if (!shouldCheck || !hospitalId || !complexity) {
    return null
  }

  return {
    hospitalId,
    complexity,
    initialDate: getSchedulingLimitInitialDate(),
    roomId,
    surgeryCenterId,
  }
}

export async function getInvalidSchedulingDates(params: SurgerySchedulingLimitParams): Promise<InvalidSchedulingDate[]> {
  const hospitalInvalidSchedulingDatesRequest = await Apis.Agendamento.SolicitacaoCirurgiaApi.getHospitalInvalidSchedulingDates(params)

  if (
    !hospitalInvalidSchedulingDatesRequest.success
    || !hospitalInvalidSchedulingDatesRequest.data
    || (hospitalInvalidSchedulingDatesRequest.data && hospitalInvalidSchedulingDatesRequest.data.length < 1)
  ) {
    return []
  }

  return hospitalInvalidSchedulingDatesRequest.data.map(item => ({
    data: moment(item.data, 'YYYY-MM-DD').format('YYYY-MM-DD'),
  }))
}

export function isInvalidSchedulingDate(invalidSchedulingDates: InvalidSchedulingDate[], surgeryDate?: string | Date | null) {
  if (!surgeryDate) return false

  const normalizedSurgeryDate = moment(surgeryDate).format('YYYY-MM-DD')
  return invalidSchedulingDates.some(item => item.data === normalizedSurgeryDate)
}
